import { render, staticRenderFns } from "./profile-edit-form.vue?vue&type=template&id=3cb7acbe&scoped=true&"
import script from "./profile-edit-form.vue?vue&type=script&lang=js&"
export * from "./profile-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit-form.vue?vue&type=style&index=0&id=3cb7acbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7acbe",
  null
  
)

export default component.exports